import {
  Grid,
  GridProps,
  Stack,
  StackProps,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { ElementType } from "react";
import { OverlayStack } from "../CtaOverlay/CtaOverlay.styles";

type IHeroBanneContainer = {
  videoVisible: boolean,
  isActive: boolean,
  isTablet: boolean,
  isLarge: boolean,
  coverPublicURL: string
}
export const HeroBannerContainer = styled(Stack)<StackProps & IHeroBanneContainer>(({ 
  theme, 
  coverPublicURL,
  isActive,
  isTablet
}) => ({
  background:
   coverPublicURL
     ? `url(${coverPublicURL})`
     : theme.customColors.backgroundPrimary,
  backgroundPosition: "center",
  backgroundRepeat:"no-repeat",
  backgroundSize: "cover",
  borderBottom: `0.125rem solid ${theme.customColors.border}`,
  minHeight: "27.5rem",
  position:"relative",
  overflow: "hidden",
  marginTop: "2rem",
  transition: "all 0.35s ease-out",
  "& .box_collapse": {
    minHeight: "1.5rem",
    height: "1.5rem",
    opacity: 0,
    transition: "all 0.35s linear"
  },
  "& .collapse_cta": {
    opacity: 0,
    height: "0rem",
    transition: "all 0.35s ease" 
  },
  "& #hero-banner-breadcrumbs": {
    opacity: 0,
    transition: "all 0.35s  linear",
    "&.active":{
      opacity: 1,
      transition: "all 0.35s linear"
    }
  },
  "& #cta-overlay": {
    opacity: 0,
    transition: "all 0.35s ease" 
  },
  ...((isActive || isTablet) && {
    transition: "opacity 0.35s linear",
    "& .lo_tag_list, .hidden": {
      opacity: 1,
      height: "unset",
      marginBottom: "0.75rem"
    },
    "& .box_collapse": {
      minHeight: "3rem",
      height: "fit-content",
      opacity: 1
    },
    "& .herobanner-badges": {
      opacity: 1,
      height: "unset",
      top: "3rem"
    },
    "& .collapse_cta": {
      opacity: 1,
      height: "3.5rem",
      transition: "all 0.35s linear"
    },
    "& .herobanner-info": {
      gap: "1rem"
    },
    "& #hero-banner-breadcrumbs": {
      opacity: 1,
      transition: "all 0.35s ease" 
    },
    "& #cta-overlay": {
      opacity: 1 ,
      transition: "all 0.35s ease" 
    }
  })
}));

export const HeroBannerMask = styled(Stack)<StackProps & {
   isActive: boolean,
   isMobile: boolean, 
   isLarge: boolean,
   isTablet: boolean, 
   isTabletHorizzontal: boolean
  }>(({ 
    theme,
    isActive,
    isTablet, 
    isLarge,
    isTabletHorizzontal
  }) => ({
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: "10%",
    left: isLarge ? "45%": "50%",
    width: "calc(100% + 200vh)",
    height: "150vh",
    zIndex: 2,
    transformOrigin: "55% 0%",
    background: `linear-gradient(to bottom, transparent 0%, ${theme.customColors.backgroundCard}77 5%, ${theme.customColors.backgroundCard} 15%)` ,
    transform: `translateX(-50%) ${isActive ? "rotate(90deg)" : "rotate(0deg)"}`,
    transition: "all .4s ease-in-out",
    ...(isActive && isTabletHorizzontal) && {
      left: "54%"
    },
    ...((isTablet) && {
      transform: "translateX(-50%) rotate(0deg) !important",
      background: `linear-gradient(to bottom, transparent 0%, ${theme.customColors.backgroundCard} 12%) !important`
    
    })
  }));

export const HeroBannerMaskBlock = styled("div")(({ theme }) => ({
  position: "absolute",
  top:0,
  left: "-100%",
  width: "40%",
  height: "100%",
  zIndex: 2,
  background: `linear-gradient(to left, transparent, ${theme.customColors.backgroundCard} 50%)`,
  transition: "all 0.35s ease-out"
}));

export const HeroBannerInfo= styled(Stack)<
  & StackProps
  & {
    component: ElementType } // monkeypatch to fix property 'component' does not exist on type 'intrinsicattributes'
>(({ theme }) => ({
  justifyContent: "flex-end",
  minHeight: "fit-content",
  padding: "4.5rem 2.5rem 0.5rem",
  width: "100%",
  gap: "0rem",
  flexGrow: 1,
  zIndex: 3,
  ".status-box": {
    left:"-42px",
    marginBottom:"42px",
    position:"relative",
    top:"50",

    height:"60px",
    width:"60px"

  },

  "& .MuiChip-root": {
    border: `2.925px solid ${theme.customColors.borderTag}`,
    borderRadius: "0.4875rem",

    "& span": {
      fontSize: "1.125rem",
      fontWeight: "700",
      letterSpacing: "1.95px",
      lineHeight: "0.9375rem"
    }
  },

  [theme.breakpoints.down("sm")]: {
    //background: `url(${coverPublicURL})`,
    //backgroundRepeat:"no-repeat",
    //backgroundSize: "contain",
    ".card-cta":{
      ">div":{
        alignItems: "flex-start",
        gap: theme.spacing(1),

        "a": {
          marginTop: theme.spacing(1)
        }
      }
    },
    ".card-signature .icon": {
      height:"20px",
      width:"20px"
    },
    ".status-box": {
      height:"40px",
      width:"40px",

      left:"-20px",

      ".icon":{
        height:"19px",
        width:"19px"
      }

    },
    ".type":{
      fontSize:"1rem"
    },

    [`${OverlayStack}`]:{
      marginTop:"18px"
    }

  }

}));


export const DetailTypography = styled(Typography)(({ theme }) => ({
  fontSize: "2rem",
  lineHeight: 1.1875,
  marginBottom:"11px",
  maxWidth:"75%",

  "-webkit-box-orient": "vertical",
  "-webkit-line-clamp": "3",

  display: "-webkit-box",
  overflow: "hidden",
  textOverflow: "ellipsis",

  [theme.breakpoints.down("sm")]: {
    fontSize:"0.875rem",
    marginBottom:"10px",
    maxWidth:"100%"
  }
}));


export const TitleTypography = styled(Typography)(({ theme }) => ({
  ".primary": {
    color: theme.customColors?.exploreCardText
  },
  fontSize: "1.25rem",
  fontWeight:"700",
  lineHeight: "1.25rem",
  whiteSpace: "normal",
  wordWrap: "break-word",

  [theme.breakpoints.down("md")]: {
    maxWidth:"100%"
  }
}));

export const StyledBadgeHero = styled(Grid)<GridProps>(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.customColors.backgroundAccent,
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  color: theme.customColors.textPrimaryAlternative,
  display: "flex",
  fontSize: "16px",
  fontWeight:500,
  gap: "1rem",
  justifyContent: "center",
  left: "0",
  lineHeight: theme.spacing(3.75),
  padding: "5px 24px !important",
  // position: "absolute",
  width: "fit-content",

  [theme.breakpoints.down("sm")]: {
    fontSize: "0.875rem",
    padding: "8px 16px"
  }
}));

export const StyledIconLock = styled(Grid)(() => ({
  display: "flex",
  height:"fit-content",
  width: "fit-content",

  inset:"0",
  position: "absolute",

  margin:"auto"

}));


export const StatusBoxesStyle = styled("div")<{isTablet: boolean}>(({ isTablet }) => ({
  opacity: 0,
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  flexWrap: "wrap",
  zIndex: 6,
  gap: "0.5rem",
  top: "50%",
  left: "2.5rem",
  maxWidth: isTablet ? "21rem" : "unset",
  transition: "all 0.3s ease-out"
}));
